import { immutableRecords } from "../../types";
import getSubTreeWithId from "./getSubTreeWithId";

/**
 *
 * @param {TreeRecord} tree
 * @param {List} subtreeIds
 * @returns
 */
const createNewTreeFromSubtreeIds = (tree, subtreeIds) => {
  const children = subtreeIds.map(sId => getSubTreeWithId(tree, sId)).filter(s => s);
  return immutableRecords.TreeRecord({
    id: null,
    children
  });
};

export default createNewTreeFromSubtreeIds;
